import clsx from "clsx";
import Image, { StaticImageData } from "next/image";

type ResponsiveImageProps = {
  className?: string;
  imageClassName?: string;
  priority?: boolean; // set true for images "above the fold"
  src: StaticImageData | string;
  sizes?: React.ImgHTMLAttributes<HTMLImageElement>["sizes"];
  alt: string;
  placeholder?: "blur" | "empty";
};

export const ResponsiveImage: React.FC<ResponsiveImageProps> = ({
  className,
  imageClassName,
  priority,
  src,
  sizes = "100vw",
  alt,
  placeholder = "empty",
}) => {
  return (
    <div className={clsx("relative h-[300px] w-full sm:h-[400px]", className)}>
      <Image
        className={clsx("h-full w-full rounded-sm object-cover", imageClassName)}
        src={src}
        sizes={sizes}
        alt={alt}
        priority={priority}
        placeholder={placeholder}
        fill
        draggable="false"
      />
    </div>
  );
};
